// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";

// const testimonials = [
//   {
//     name: "John Doe",
//     designation: "CEO, Acme Corp",
//     feedback: "The level of legal precision at Nyaysakti is unmatched. They don't just provide advice; they provide a strategic shield for your business interests.",
//   },
//   {
//     name: "Jane Smith",
//     designation: "Founder, Tech Solutions",
//     feedback: "In legal matters, trust is everything. Their counsel has been my most valuable asset through years of complex corporate growth.",
//   },
//   {
//     name: "Michael Lee",
//     designation: "Entrepreneur",
//     feedback: "A masterclass in courtroom strategy. Their transparency and command over the law gave me confidence when I needed it most.",
//   },
// ];

// const TestimonialSlider = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const brandGold = "#E3B66B";
//   const darkGreen = "#0A1D1B";

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentIndex((prev) => (prev + 1) % testimonials.length);
//     }, 6000);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <section className="bg-white py-24 px-6 md:px-12 relative overflow-hidden font-serif">
      
//       {/* Decorative Background Element */}
//       <div className="absolute top-0 right-0 w-1/3 h-full bg-[#FAF9F6] -z-0 hidden lg:block"></div>

//       <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-16 items-center relative z-10">
        
//         {/* LEFT SIDE: Text & Navigation (5 Columns) */}
//         <div className="lg:col-span-5">
//           <div className="flex items-center gap-4 mb-8">
//             <div className={`w-12 h-[2px]`} style={{ backgroundColor: brandGold }}></div>
//             <span style={{ color: brandGold }} className="uppercase tracking-[0.5em] text-[10px] font-bold">
//               Client Testimonials
//             </span>
//           </div>
          
//           <h2 style={{ color: darkGreen }} className="text-5xl md:text-7xl font-bold leading-[1.1] mb-8">
//             Patrons <br />
//             <span className="italic font-light opacity-40">Voices</span>
//           </h2>
          
//           <p className="text-gray-500 font-sans text-lg leading-relaxed max-w-sm mb-16">
//             Our reputation is forged in the success of those we represent. 
//             Legacy is built on trust and absolute legal mastery.
//           </p>

//           {/* Luxury Custom Navigation */}
//           <div className="space-y-8">
//             {testimonials.map((t, i) => (
//               <button 
//                 key={i}
//                 onClick={() => setCurrentIndex(i)}
//                 className="flex items-center gap-6 group transition-all duration-500"
//               >
//                 <span className={`text-sm transition-all duration-500 ${currentIndex === i ? 'font-bold scale-125' : 'text-gray-300'}`}
//                       style={{ color: currentIndex === i ? darkGreen : '' }}>
//                   0{i + 1}
//                 </span>
//                 <div className="relative h-[1px] bg-gray-100 w-12 overflow-hidden">
//                   <motion.div 
//                     initial={false}
//                     animate={{ x: currentIndex === i ? 0 : -50 }}
//                     className="absolute inset-0 w-full"
//                     style={{ backgroundColor: brandGold }}
//                   />
//                 </div>
//                 <span className={`uppercase tracking-[0.3em] text-[10px] transition-all duration-500 ${currentIndex === i ? 'opacity-100 translate-x-2' : 'opacity-30'}`}
//                       style={{ color: darkGreen }}>
//                   {t.name}
//                 </span>
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* RIGHT SIDE: The "Majestic" Card (7 Columns) */}
//         <div className="lg:col-span-7 relative h-[550px] flex items-center">
          
//           {/* Static Background Frames for Depth */}
//           <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] h-[80%] border border-gray-100 -rotate-3 transition-transform duration-1000"></div>
//           <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] h-[80%] border -rotate-6 hidden md:block" style={{ borderColor: `${brandGold}20` }}></div>

//           <AnimatePresence mode="wait">
//             <motion.div
//               key={currentIndex}
//               initial={{ opacity: 0, x: 50 }}
//               animate={{ opacity: 1, x: 0 }}
//               exit={{ opacity: 0, x: -50 }}
//               transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
//               style={{ backgroundColor: darkGreen }}
//               className="relative w-full p-12 md:p-20 shadow-[40px_40px_90px_rgba(0,0,0,0.2)]"
//             >
//               {/* Gold Ornament Detail */}
//               <div className="absolute top-0 left-0 w-2 h-full" style={{ backgroundColor: brandGold }}></div>
//               <div className="absolute top-10 right-10 text-[8rem] font-serif leading-none opacity-5 select-none" style={{ color: brandGold }}>
//                 “
//               </div>

//               <div className="relative z-10">
//                 <p className="text-white text-2xl md:text-3xl font-serif italic leading-relaxed mb-12">
//                   "{testimonials[currentIndex].feedback}"
//                 </p>

//                 <div className="flex flex-col gap-2">
//                   <div className="w-12 h-[2px]" style={{ backgroundColor: brandGold }}></div>
//                   <h4 style={{ color: brandGold }} className="text-xl font-bold uppercase tracking-widest mt-4">
//                     {testimonials[currentIndex].name}
//                   </h4>
//                   <p className="text-gray-400 text-xs uppercase tracking-[0.4em] font-sans">
//                     {testimonials[currentIndex].designation}
//                   </p>
//                 </div>
//               </div>

//               {/* Decorative Corner Square */}
//               <div className="absolute bottom-0 right-0 w-16 h-16 opacity-10" 
//                    style={{ borderRight: `1px solid ${brandGold}`, borderBottom: `1px solid ${brandGold}` }}>
//               </div>
//             </motion.div>
//           </AnimatePresence>
//         </div>
//       </div>

//       {/* Subtle Bottom Watermark */}
//       <div className="absolute bottom-10 right-10 opacity-[0.02] text-6xl font-black uppercase tracking-tighter" style={{ color: darkGreen }}>
//         Nyaysakti Chambers
//       </div>
//     </section>
//   );
// };

// export default TestimonialSlider;

import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const testimonials = [
  {
    id: "01",
    name: "John Doe",
    role: "CEO, Acme Corp",
    feedback:
      "The level of legal precision is unmatched. They provide strategic guidance with transparency and deep legal expertise, ensuring confidence in every business decision.",
  },
  {
    id: "02",
    name: "Jane Smith",
    role: "Founder, Tech Solutions",
    feedback:
      "Their professionalism and dedication are exceptional. They handled my case with integrity and delivered results beyond expectations.",
  },
  {
    id: "03",
    name: "Michael Lee",
    role: "Entrepreneur",
    feedback:
      "An outstanding legal team with unmatched courtroom strategy. Their attention to detail and clarity gave me complete confidence.",
  },
];

const TestimonialSection = () => {
  const [current, setCurrent] = useState(0);

  const brandGold = "#E3B66B";
  const darkGreen = "#0B1C2D";

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex flex-col items-center py-24 overflow-hidden font-serif bg-[#FAF9F6]">
      
      {/* Background Watermark */}
      <div className="absolute inset-0 flex items-center justify-center opacity-[0.02] pointer-events-none select-none">
        <h1 className="text-[25vw] font-bold text-[#0A1D1B]">NYAYSAKTI</h1>
      </div>

      {/* --- NEW SECTION HEADING --- */}
      <div className="relative z-10 mb-16 lg:mb-24 text-center px-6">
        <div className="flex items-center justify-center gap-4 mb-4">
          <div className="w-12 h-[1px]" style={{ backgroundColor: brandGold }}></div>
          <p className="uppercase tracking-[0.6em] text-[10px] font-black" style={{ color: brandGold }}>
            Client Reviews
          </p>
          <div className="w-12 h-[1px]" style={{ backgroundColor: brandGold }}></div>
        </div>
        
        <h2 className="text-5xl lg:text-7xl font-bold tracking-tight" style={{ color: darkGreen }}>
          Review From Our Clients
        </h2>
        
        <div className="mt-6 flex justify-center items-center gap-3">
          <div className="w-2 h-2 rotate-45 border" style={{ borderColor: brandGold }}></div>
          <div className="w-16 h-[1px] opacity-30" style={{ backgroundColor: darkGreen }}></div>
          <div className="w-2 h-2 rotate-45 border" style={{ borderColor: brandGold }}></div>
        </div>
      </div>
      {/* --- END HEADING --- */}

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16 relative z-10 w-full items-center">

        {/* LEFT SIDE: Content & Nav */}
        <div className="lg:col-span-5 space-y-8 text-center lg:text-left">
          <div>
            <h3 className="text-4xl lg:text-6xl font-bold leading-tight" style={{ color: darkGreen }}>
              Review From Our Clients <br />
              <span className=" font-light opacity-60">Perspectives</span>
            </h3>
          </div>

          <p className="text-gray-500 font-sans text-base lg:text-lg max-w-md mx-auto lg:mx-0 leading-relaxed italic border-l-0 lg:border-l-2 lg:pl-6" style={{ borderColor: brandGold }}>
            "Justice is not just a result, but a process of integrity. Our clients' trust is our greatest achievement."
          </p>

          {/* Indicators */}
          <div className="flex flex-row lg:flex-col justify-center lg:justify-start gap-6 pt-6">
            {testimonials.map((t, i) => (
              <button 
                key={i} 
                onClick={() => setCurrent(i)}
                className="flex items-center gap-4 group"
              >
                <span className={`text-xs font-bold transition-all duration-500 ${current === i ? 'scale-125' : 'opacity-20'}`} style={{ color: darkGreen }}>
                  {t.id}
                </span>
                <div className="w-10 lg:w-20 h-[1px] bg-gray-200 relative overflow-hidden hidden sm:block">
                  <motion.div 
                    animate={{ x: current === i ? 0 : -80 }}
                    className="absolute inset-0 w-full"
                    style={{ backgroundColor: brandGold }}
                  />
                </div>
                <span className={`uppercase tracking-widest text-[10px] hidden lg:block transition-all duration-500 ${current === i ? 'opacity-100 translate-x-2' : 'opacity-20'}`} style={{ color: darkGreen }}>
                  {t.name}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* RIGHT SIDE: Elevated Card */}
        <div className="lg:col-span-7 relative flex items-center justify-center min-h-[450px]">
          
          <div className="absolute w-[90%] h-[80%] border-2 -rotate-3 translate-x-2 translate-y-2 opacity-10" style={{ borderColor: darkGreen }} />
          <div className="absolute w-[90%] h-[80%] border-2 rotate-6 -translate-x-2 -translate-y-2 opacity-20" style={{ borderColor: brandGold }} />

          <AnimatePresence mode="wait">
            <motion.div
              key={current}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              style={{ backgroundColor: darkGreen, borderBottom: `8px solid ${brandGold}` }}
              className="relative w-full max-w-xl p-10 lg:p-16 shadow-[0_50px_100px_rgba(0,0,0,0.2)]"
            >
              <div className="absolute -top-6 -left-6 w-16 h-16 bg-white shadow-xl flex items-center justify-center rotate-3 hidden lg:flex">
                 <span className="text-4xl leading-none mt-4" style={{ color: brandGold }}>“</span>
              </div>

              <div className="relative z-10">
                <p className="text-white text-lg lg:text-2xl font-light italic leading-relaxed mb-12">
                  "{testimonials[current].feedback}"
                </p>
                
                <div className="flex flex-col gap-1 border-t pt-8" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
                  <h4 className="text-lg lg:text-xl font-bold uppercase tracking-[0.2em]" style={{ color: brandGold }}>
                    {testimonials[current].name}
                  </h4>
                  <p className="text-gray-400 text-[10px] lg:text-xs uppercase tracking-[0.3em] font-sans">
                    {testimonials[current].role}
                  </p>
                </div>
              </div>

              <div className="absolute bottom-6 right-6 w-8 h-8 opacity-20 border-r border-b" style={{ borderColor: brandGold }}></div>
            </motion.div>
          </AnimatePresence>
        </div>

      </div>
    </section>
  );
};

export default TestimonialSection;